import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Global } from "../../../Variables/Global";
import axiosInstance from '../../../api/axiosConfig';

const ManageExpensesType = () => {
    var pId = useParams();
    var navigate = useNavigate();
    const axios = require('axios').default;
    const token = localStorage.getItem('token');
    if (!token) {
        window.location.reload();
    }
    axios.defaults.headers.Authorization = `Bearer ${token}`;
    const [pageType, setPageType] = useState("Add");
    const [expensesType, setExpensesType] = useState("");
    const [notes, setNotes] = useState("");
    const [companyId, setCompanyId] = useState(0);
    const [companies, setCompanies] = useState([]);

    const GetProductExpensesType = (expensesTypeId) => {
        var config = {
            method: 'get',
            url: "GetExpensesType?expensesTypeId=" + expensesTypeId,
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                setExpensesType(response.data.data.expensesType1)
                setNotes(response.data.data.notes)
                setCompanyId(response.data.data.companyId)
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const GetCompanies = () => {
        var config = {
            method: 'get',
            url: "Company/GetCompany",
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': Global.Host
            },
        };

        axiosInstance(config)
            .then(function (response) {
                setCompanies(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const submitForm = (e) => {
        e.preventDefault();
        if (IsValid()) {
            const body = { 
                expensesType: expensesType, 
                notes: notes, 
                userId: localStorage.getItem("uTsReD"),
                companyId: localStorage.getItem("C0m8N!") 
            }
            if (pId.ExpensesTypeId == "0") { //Add Product Expenses Type
                var config = {
                    method: 'post',
                    url: "ExpensesType/AddExpensesType",
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': Global.Host
                    },
                    data: body
                };

                axiosInstance(config)
                    .then(function (response) {
                        if (response.status === 200) {
                            toast.success("Expenses Type Added Successfully")
                            navigate("/Accounting/ExpensesType")
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        toast.error("Something Went Wrong")
                    });
            }
            else { // Update Product Expenses Type
                var config = {
                    method: 'put',
                    url: "ExpensesType/EditExpensesType/" + pId.ExpensesTypeId,
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': Global.Host
                    },
                    data: body
                };

                axiosInstance(config)
                    .then(function (response) {
                        if (response.status === 200) {
                            toast.success("Expenses Type Updated Successfully")
                            navigate("/Accounting/ExpensesType")
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        toast.error("Something Went Wrong")
                    });
            }
        }
    }

    const IsValid = () => {
        if (expensesType == "") {
            toast.error("Enter all required fields");
            return false;
        }
        return true;
    }

    useEffect(() => {
        document.title = "Manage Expenses Types";
        GetCompanies();
        if (pId.ExpensesTypeId != "0") {
            setPageType("Edit");
            GetProductExpensesType(pId.ExpensesTypeId)
        }
    }, [])
    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-6">
                            <div className="page-title-box">
                                <h4>Expenses Types</h4>
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><a href="#">Mercator</a></li>
                                    <li className="breadcrumb-item"><Link to="/Accounting/ExpensesType">Expenses Types</Link></li>
                                    <li className="breadcrumb-item active">{pageType} Expenses Type</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="mb-3 row">
                                        <div className="col-12 col-md-6">
                                            <h4 className="card-title">{pageType} Expenses Type</h4>
                                        </div>
                                        <div className="col-12 col-md-6 text-right">
                                            <Link to="/Accounting/ExpensesType" className="btn btn-secondary mr-3">Cancel</Link>
                                            <button className="btn btn-primary" onClick={(e) => submitForm(e)}>Submit</button>
                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <div className="col-md-6">
                                            <label htmlFor="txtSizeName" className="col-md-12 col-form-label">Expenses Type Name</label>
                                            <input className="form-control" type="text" value={expensesType} id="txtSizeName" onChange={(e) => setExpensesType(e.target.value)} required />
                                        </div>
                                        {/* <div className="col-md-6">
                                            <label className="col-md-12 col-form-label">Company</label>
                                            <select className="form-control" value={companyId} onChange={(e) => setCompanyId(e.target.value)} required>
                                                <option value="0" key="0">-- Select Company Name --</option>
                                                {companies.length > 0 && (
                                                    companies.map((c, index) => {
                                                        return (<>
                                                            <option value={c.companyId} key={index}>{c.companyName}</option>
                                                        </>)
                                                    })
                                                )}
                                            </select>
                                        </div> */}
                                        <div className="col-md-6">
                                            <label htmlFor="txtSizeName" className="col-md-12 col-form-label">Notes</label>
                                            <textarea className="form-control" type="text" value={notes} id="txtSizeName" onChange={(e) => setNotes(e.target.value)} required />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
export default ManageExpensesType;